import React from 'react'
import { Col, Row } from 'react-flexbox-grid'
import { ContentBlock } from 'components/ContentBlock'
import { Link } from 'react-router-dom'

const HasParentCategory = ({ categoryId, parentCategoryId }) => (
	<Row>
		<Col xs={12}>
			<h1>Unterkunft auf der Kasse</h1>
			<ContentBlock style={{ margin: 0 }}>
				<div>Diese Schablone ist verknüpft mit dieser <Link to={`/schablone/${parentCategoryId}`}>Schablone</Link>.</div>
				<div>Die Verknüpfung kann unter <Link to={`/schablone/optionen/${categoryId}`}>Optionen</Link> zurückgesetzt werden.</div>
			</ContentBlock>
		</Col>
	</Row>
)

export default HasParentCategory
